import { FilterBase } from "../filterBase"
import { DATA_TYPES } from "../filterConstants"

export class ListFilter extends FilterBase {
  constructor(filterName, filterType, dataScopes, information, visibility, restrictedToScope) {
    super(
      filterName,
      filterType,
      DATA_TYPES.LIST,
      dataScopes,
      information,
      visibility,
      restrictedToScope,
    )
  }

  formatCompareData(a, b) {
    return [a?.join(", ")?.toLowerCase(), b?.join(", ")?.toLowerCase()]
  }

  isValueValid(_value) {
    return true
  }

  additionalFilters(data) {
    return data.filter(
      (row) =>
        row[this.filterType] &&
        row[this.filterType].filter((x) => x.toLowerCase().includes(this.value.toLowerCase()))
          .length > 0,
    )
  }
}
